/**
 * A People's Chant background music — iter M642.
 *
 * Plays the user-supplied /sounds/vielle.mp3 (medieval vielle melody)
 * on loop while the visitor is on /games/peoples-chant.  Same
 * architecture as karnoffelMusic.js: one shared HTMLAudioElement,
 * honours the global mute flag, autoplay-policy safe when started
 * inside a user gesture.
 */
const TRACK_URL = "/sounds/vielle.mp3";

let _audio = null;

const isMuted = () => {
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      return window.localStorage.getItem("studio:muted") === "1";
    }
  } catch { /* */ }
  return false;
};

const getAudio = () => {
  if (typeof window === "undefined") return null;
  if (!_audio) {
    try {
      _audio = new Audio(TRACK_URL);
      _audio.loop = true;
      _audio.preload = "auto";
      _audio.volume = 0.5;
    } catch { return null; }
  }
  return _audio;
};

export function startChantMusic() {
  const a = getAudio();
  if (!a) return;
  if (isMuted()) return;
  if (!a.paused) return;
  try {
    const p = a.play();
    if (p && typeof p.then === "function") p.catch(() => { /* autoplay blocked */ });
  } catch { /* */ }
}

export function stopChantMusic() {
  if (!_audio) return;
  try {
    _audio.pause();
    _audio.currentTime = 0;
  } catch { /* */ }
}

// Honoured by the GlobalMuteButton — pauses the loop instantly on
// mute, resumes it on un-mute only if the visitor is still on the
// chant route.
export function applyChantMuteFlag() {
  if (!_audio) return;
  if (isMuted()) {
    try { _audio.pause(); } catch { /* */ }
  } else {
    if (typeof window !== "undefined" &&
        window.location &&
        window.location.pathname.startsWith("/games/peoples-chant")) {
      try {
        const p = _audio.play();
        if (p && typeof p.then === "function") p.catch(() => { /* */ });
      } catch { /* */ }
    }
  }
}
